module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pmybaogao-wrap"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBaoGao),
      expression: "isBaoGao"
    }],
    staticClass: "baoGaoList"
  }, [_c('div', {
    staticStyle: {
      "height": ".4rem"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": ".56rem"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNull),
      expression: "isNull"
    }],
    staticClass: "mybaogao-null"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/nullbaogao.png")
    }
  }), _vm._v(" "), _c('h5', [_vm._v("\n\t\t\t如果想查询报告，请先完善信息\n\t\t")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('myheader')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-content"
  }, [_c('div', [_c('p', [_c('b', [_vm._v("检测人 : ")]), _vm._v(" "), _c('span', [_vm._v("陆大鸟")])]), _vm._v(" "), _c('p', [_c('i', [_vm._v("查看")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("检测结果 : ")]), _vm._v(" "), _c('span', [_vm._v("良好")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("检测时间 : ")]), _vm._v(" "), _c('span', [_vm._v("2017-05-25")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("检测套餐 : ")]), _vm._v(" "), _c('span', [_vm._v("青年版-VIP套餐")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', [_vm._v("因涉及个人数据隐私")]), _vm._v(" "), _c('span', [_vm._v("查询数据前请务必注册信息或进行微信绑定")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3bd2b4a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/phonecomponents/mybaogao.vue
// module id = 770
// module chunks = 1